$(document).ready(function () {

    $('[data-meter-id]').each(function (){
        const $dtCorr = $(this).find('[name="datetime_correspondence"]')
        const $dtDiff = $(this).find('[name="datetime_diff"]')

        if(!$dtCorr.length || !$dtDiff.length) return true;

        /* Спрячем зависимое поле */
        if($dtCorr.is(':checked')){
            $dtDiff.closest('.act-info__table-row').hide()
        }

        /* Событие переключатель Соответстуует/Не соответствует время корректора */
        $dtCorr.click(e => {
            const $checkbox = $(e.target)
            const $row = $checkbox.closest('.act-info__table-row')
            const $nextRow = $row.next()

            $nextRow.slideToggle()
        })
    })
})
